
import {define} from "observable:runtime";
import asset1 from "./style.css?url";
import asset2 from "./favicon.svg?url";

const assets = new Map([
  ["./style.css", asset1],
  ["./favicon.svg", asset2]
]);

define(
  {
    root: document.getElementById(`cell-2`),
    expanded: [],
    variables: []
  },
  {
    id: 2,
    body: async (html,display) => {
const {createUI, installHashImportBanner, installThemeToggle, runWithTimeout} = await import("./lib/helpers.js").then((module) => {
  if (!("createUI" in module)) throw new SyntaxError(`export 'createUI' not found`);
  if (!("installHashImportBanner" in module)) throw new SyntaxError(`export 'installHashImportBanner' not found`);
  if (!("installThemeToggle" in module)) throw new SyntaxError(`export 'installThemeToggle' not found`);
  if (!("runWithTimeout" in module)) throw new SyntaxError(`export 'runWithTimeout' not found`);
  return module;
});
installThemeToggle({ html, display });
installHashImportBanner({ html, display });
const { codeEditor, consoleOutput } = createUI({ html });
return {createUI,installHashImportBanner,installThemeToggle,runWithTimeout,codeEditor,consoleOutput};
},
    inputs: ["html","display"],
    outputs: ["createUI","installHashImportBanner","installThemeToggle","runWithTimeout","codeEditor","consoleOutput"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-5`),
    expanded: [],
    variables: []
  },
  {
    id: 5,
    body: (view,codeEditor) => {
const demo_lokal = view(codeEditor("scopes:lokal", {
  value: 'const a = 10\n\nif (a > 8) {\n  const b = a + 5 // b lebt nur in diesem Block\n  console.log(b)\n}\n\n// Hier außerhalb gibt es kein b mehr.\n// Wenn du die nächste Zeile aktivierst, gibt es einen Fehler:\n// console.log(b)'
}));
return {demo_lokal};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_lokal"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-6`),
    expanded: [],
    variables: []
  },
  {
    id: 6,
    body: async (display,consoleOutput,runWithTimeout,demo_lokal) => {
display(consoleOutput(await runWithTimeout(demo_lokal)));
},
    inputs: ["display","consoleOutput","runWithTimeout","demo_lokal"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-9`),
    expanded: [],
    variables: []
  },
  {
    id: 9,
    body: (view,codeEditor) => {
const demo_komplex = view(codeEditor("scopes:komplex", {
  value: 'const target = 30\nlet n = 2\n\nwhile (n < target) {\n  // Scope der äußeren Schleife\n  let isPrim = true\n  let maybeTeiler = 2\n\n  while (maybeTeiler < n) {\n    // Scope der inneren Schleife\n    if (n % maybeTeiler == 0) {\n      isPrim = false\n      break\n    }\n    maybeTeiler = maybeTeiler + 1\n  }\n\n  if (isPrim) {\n    console.log(n)\n  }\n  n = n + 1\n}'
}));
return {demo_komplex};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_komplex"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-10`),
    expanded: [],
    variables: []
  },
  {
    id: 10,
    body: async (display,consoleOutput,runWithTimeout,demo_komplex) => {
display(consoleOutput(await runWithTimeout(demo_komplex)));
},
    inputs: ["display","consoleOutput","runWithTimeout","demo_komplex"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
